"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsSwitch = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
const _excluded = ["name", "checkedValue", "uncheckedValue", "checked", "onChange", "label", "labelProps"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A switch component that wraps Material-UI's Switch with additional label support.
 * It allows for customizable values to be sent when the switch is toggled.
 *
 * @param {Object} props - The props for the DmsSwitch component.
 * @param {string} props.name - The name attribute for the switch.
 * @param {string} [props.checkedValue='true'] - The value to be sent when the switch is checked.
 * @param {string} [props.uncheckedValue='false'] - The value to be sent when the switch is unchecked.
 * @param {boolean} [props.checked=false] - The initial state of the switch.
 * @param {Function} [props.onChange] - Callback function called when the switch state changes.
 * @param {string} [props.label=''] - The label to be displayed with the switch.
 * @param {Object} [props.labelProps={}] - Additional props to pass to FormControlLabel.
 * @param {string} [props.color='default'] - The color of the switch.
 * @param {string} [props.size='medium'] - The size of the switch.
 * @param {string} [props.edge] - The edge of the switch.
 * @param {Object} [props.inputProps={}] - Props to pass to the input element of the switch.
 * @param {React.Ref} [props.inputRef] - Ref for the input element.
 * @param {Object} [props.classes={}] - Custom styles for the switch.
 * @param {Object} [props.sx={}] - System-based styles for the switch.
 * @param {...Object} props - Additional props to be passed to the Switch component.
 *
 * @returns {React.Element} The rendered DmsSwitch component.
 */
const DmsSwitch = _ref => {
  let {
      name,
      checkedValue = "true",
      uncheckedValue = "false",
      checked = false,
      onChange,
      label = "",
      labelProps = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [isChecked, setIsChecked] = (0, _react.useState)(checked);
  const [switchValue, setSwitchValue] = (0, _react.useState)(checked ? checkedValue : uncheckedValue);
  (0, _react.useEffect)(() => {
    setIsChecked(checked);
    setSwitchValue(checked ? checkedValue : uncheckedValue);
  }, [checked, checkedValue, uncheckedValue]);
  const handleChange = event => {
    const newChecked = event.target.checked;
    const newValue = newChecked ? checkedValue : uncheckedValue;
    setIsChecked(newChecked);
    setSwitchValue(newValue);
    if (onChange) {
      onChange(name, newValue);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, _extends({
    control: /*#__PURE__*/_react.default.createElement(_material.Switch, _extends({
      name: name,
      checked: isChecked,
      value: switchValue,
      onChange: handleChange
    }, props)),
    label: label
  }, labelProps));
};
exports.DmsSwitch = DmsSwitch;
DmsSwitch.propTypes = {
  name: _propTypes.default.string.isRequired,
  checkedValue: _propTypes.default.string,
  uncheckedValue: _propTypes.default.string,
  checked: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  label: _propTypes.default.string,
  labelProps: _propTypes.default.shape({
    labelPlacement: _propTypes.default.oneOf(["end", "start", "top", "bottom"]),
    control: _propTypes.default.node,
    disabled: _propTypes.default.bool,
    classes: _propTypes.default.object,
    sx: _propTypes.default.object
  }),
  color: _propTypes.default.oneOf(["default", "primary", "secondary"]),
  size: _propTypes.default.oneOf(["small", "medium"]),
  edge: _propTypes.default.oneOf(["start", "end", false]),
  inputProps: _propTypes.default.object,
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]),
  classes: _propTypes.default.object,
  sx: _propTypes.default.object
};